// extracted by mini-css-extract-plugin
export default {"title":"Welcome_title__EAh1s"};